module.exports = __webpack_public_path__ + "static/media/0501localteam-shirt.28ac0df5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/0501localteam-shirt.jpg
// module id = 398
// module chunks = 0